'use strict';

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function BrandMetacriticLogo(props) {
    return (React__namespace.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", width: "1em", height: "1em" }, props),
        React__namespace.createElement("g", { clipPath: "url(#BrandMetacriticLogo__mlj76qxwua)" },
            React__namespace.createElement("path", { fill: "#FFCC34", d: "M20 9.966C20 15.488 15.442 20 9.864 20 4.286 20-.204 15.488-.204 9.966-.204 4.512 4.286 0 9.864 0 15.442 0 20 4.512 20 9.966z" }),
            React__namespace.createElement("path", { fill: "#333", d: "M18.027 9.967c0 4.444-3.605 8.013-8.095 8.013s-8.095-3.569-8.095-8.013c0-4.445 3.605-8.014 8.095-8.014 4.422 0 8.095 3.57 8.095 8.014z" }),
            React__namespace.createElement("path", { fill: "#FEFEFE", d: "M4.626 12.727c-.68-.673-1.293-1.28-1.837-1.75l1.497-1.482.816.673.068-.067c-.136-.539-.204-1.549.748-2.492.749-.74 1.701-.942 2.517-.538-.068-.539-.068-1.01.068-1.414.136-.472.409-.943.817-1.347 1.088-1.078 2.653-1.145 4.353.538l3.334 3.3-1.7 1.684-3.062-3.03c-.816-.809-1.565-1.01-2.109-.472-.408.404-.408.943-.204 1.414.068.135.272.337.408.471l3.333 3.3-1.7 1.684-3.13-3.098c-.68-.673-1.428-.943-2.04-.337-.477.472-.34 1.078-.204 1.414.068.202.204.337.408.54l3.265 3.232-1.7 1.683-3.946-3.906z" })),
        React__namespace.createElement("defs", null,
            React__namespace.createElement("clipPath", { id: "BrandMetacriticLogo__mlj76qxwua" },
                React__namespace.createElement("path", { fill: "#fff", d: "M0 0h20v20H0z" })))));
}

module.exports = BrandMetacriticLogo;
